import { Box } from "@material-ui/core";
import { TimePickerView } from "@material-ui/pickers";
import { TabPanel, TabPanelProps } from "./";
import { TimePickerViewProps } from "@material-ui/pickers/views/Clock/ClockView";
import { Dispatch, SetStateAction, useState } from "react";
import classes from "./TimeTab.module.css";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

type Props = {
  date: Date;
  setDate: Dispatch<SetStateAction<Date>>;
  type: TimePickerViewProps["type"];
  setType: Dispatch<SetStateAction<TimePickerViewProps["type"]>>;
  currentTab: TabPanelProps["value"];
};

export const TimeTab = ({
  date,
  setDate,
  setType,
  type,
  currentTab,
}: Props) => {
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

  const changeHandler = (
    date: MaterialUiPickersDate,
    type: "Hours" | "Minutes" | "Seconds"
  ) => {
    if (!date) return;
    if (timer) {
      clearTimeout(timer);
    }
    setTimer(
      setTimeout(() => {
        setDate((prev) => {
          const newDate = new Date(prev);
          newDate[`set${type}`](date[`get${type}`]());
          return newDate;
        });
      }, 5)
    );
  };

  return (
    <TabPanel value={currentTab} index={1}>
      <Box style={{ width: "100%", height: 305 }} className={classes.test}>
        <TimePickerView
          date={date}
          type={type}
          onHourChange={(date, isFinish) => {
            changeHandler(date, "Hours");
            if (!isFinish) return;
            setType("minutes");
          }}
          onMinutesChange={(date, isFinish) => {
            changeHandler(date, "Minutes");
            if (!isFinish) return;
            setType("seconds");
          }}
          onSecondsChange={(date) => changeHandler(date, "Seconds")}
        ></TimePickerView>
      </Box>
    </TabPanel>
  );
};
